import { REQUEST_TYPE, RequestTypeDic } from '@services/constants'
import { Request } from 'typings/shared'
import { normalizeTrackingLabel } from '@utils/trackingNaming'

const resolveCanonicalFormType = (request: Request | undefined): string => {
	const templateType = request?.templateType
		? RequestTypeDic[request.templateType]
		: REQUEST_TYPE.PLAIN

	if (templateType === REQUEST_TYPE.TN ) {
		return 'TN'
	}
	if (templateType === REQUEST_TYPE.TN_UR) {
		return 'TN_URB'
	}

	return 'simple'
}

const normalizeFormStepName = (stepName: string): string =>
	stepName
		.normalize('NFC')
		.toLowerCase()
		.replace(/[^a-z0-9\u00c0-\u024f]+/g, '_')
		.replace(/^_+|_+$/g, '')

export type FormStepTrackingPayload = {
	form_step: number
	form_step_id: string
	form_steps_count: number
}

export const buildFormStepTrackingPayload = (
	stepIndex: number,
	stepName: string,
	stepsCount: number
): FormStepTrackingPayload | undefined => {
	const normalizedStepName = normalizeFormStepName(stepName)

	if (
		!Number.isFinite(stepIndex) ||
		!Number.isInteger(stepsCount) ||
		stepIndex < 1 ||
		stepsCount < Math.floor(stepIndex) ||
		!normalizedStepName
	) {
		return undefined
	}

	return {
		form_step: stepIndex,
		form_step_id: `${stepIndex}:${normalizedStepName}`,
		form_steps_count: stepsCount
	}
}

export const buildNestedFormStepTrackingPayload = (
	outerStepIndex: number,
	outerStepName: string,
	outerStepsCount: number,
	stepPosition: string,
	stepNames: string[]
): FormStepTrackingPayload | undefined => {
	const nestedStepIndex = stepNames.indexOf(stepPosition)

	if (nestedStepIndex < 0) {
		return undefined
	}

	return buildFormStepTrackingPayload(
		Number(`${outerStepIndex}.${nestedStepIndex + 1}`),
		outerStepName,
		outerStepsCount
	)
}

export const resolveFrenchRequestTitle = (
	request: Request | undefined,
	frenchRequests: Request[] = []
): string =>
	frenchRequests.find(
		(candidate) => candidate.requestId === request?.requestId
	)?.title || ''

export const buildCanonicalFormTrackingPayload = (
	request: Request | undefined,
	fallbackFormId: string,
	frenchRequests: Request[] = []
) => {
	const formName =
		resolveFrenchRequestTitle(request, frenchRequests) || fallbackFormId

	return {
		form_id: request?.requestId || fallbackFormId,
		form_name: normalizeTrackingLabel(formName),
		form_type: resolveCanonicalFormType(request)
	}
}
